import React, { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { QuantityInputElement } from './elements'
import { productVariationFormQuantityState } from './productVariationFormState'

export const ProductVariationsQuantityInput = ({ register, setValue }) => {
  const [quantity, setQuantity] = useRecoilState(productVariationFormQuantityState)

  useEffect(() => {
    return () => setQuantity(1)
  }, [])

  const handleSetValue = (name, value) => {
    if (value > 0) {
      setValue(name, value)
    }
    else {
      setValue(name, 1)
    }
  }

  return <QuantityInputElement 
    elementName={'quantity'}
    defaultValue={quantity}
    quantity={quantity}
    setQuantity={setQuantity}
    setValue={handleSetValue}
    register={register('quantity', {
      min: 1,
      required: true,
      onChange: (event) => {
        const newQuantity = parseInt(event.target.value)
        if (newQuantity > 0) {
          setValue('quantity', newQuantity)
          setQuantity(newQuantity)
        }
      }
    })} />
}
